import { accessCardService, householdService } from "@services";
import { maskActions } from "./mask.actions";
import { householdConstants } from "@constants";
import { message, Tooltip } from "antd";
import { msgTypes, showModal } from "@utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as Motor } from "@styles/svgs/icon-motor.svg";
import { InfoCircleOutlined } from "@ant-design/icons";
import CommonTag from "@components/CommonTag";

export const householdActions = {
  /**
   * 取得建案住戶列表
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: householdConstants.GET_ALL_REQUEST
      });

      householdService.getAll(constructionUuid, condition).then(
        ({ items, total }) => {
          dispatch({
            type: householdConstants.GET_ALL_SUCCESS,
            constructionUuid,
            items,
            total,
            condition
          });
        },
        error => {
          dispatch({
            type: householdConstants.GET_ALL_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重設建案住戶列表
   * @returns
   */
  resetAll: () => ({
    type: householdConstants.RESET_ALL_SUCCESS
  }),
  /**
   * 重設建案戶別清單
   * @returns
   */
  resetList: () => ({
    type: householdConstants.RESET_LIST_SUCCESS
  }),
  /**
   * 更新戶別資訊
   * @param {number} id - 戶別 id
   * @param {object} info - 戶別資訊
   * @param {function} cbSuccess - 成功後的 callback
   * @returns
   */
  update: (id, info, cbSuccess) => {
    return (dispatch, getState) => {
      dispatch({
        type: householdConstants.EDIT_HOUSEHOLD_REQUEST
      });
      householdService.update(id, info).then(
        response => {
          dispatch({
            type: householdConstants.EDIT_HOUSEHOLD_SUCCESS
          });

          cbSuccess && cbSuccess();
          message.success(response);
          householdActions.__getAll(dispatch, getState);
        },
        error => {
          dispatch({
            type: householdConstants.EDIT_HOUSEHOLD_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重設更新戶別資訊
   * @returns
   */
  resetUpdate: () => ({
    type: householdConstants.RESET_EDIT_HOUSEHOLD_SUCCESS
  }),
  /**
   * 取得建物住戶資訊
   * @param {number} id - 戶別 id
   * @param {function} cbSuccess - 成功後的 callback
   * @param {function} cbError - 失敗後的 callback
   * @returns
   */
  getEdited: (id, cbSuccess, cbError) => {
    return dispatch => {
      dispatch({
        type: householdConstants.GET_HOUSEHOLD_EDIT_REQUEST
      });
      householdService.get(id).then(
        household => {
          dispatch({
            type: householdConstants.GET_HOUSEHOLD_EDIT_SUCCESS
          });

          const { users, parking_spaces, access_cards } = household;
          const majorUser = users.find(user => user.is_major);
          const transferedHousehold = {
            ...household,
            major_user: majorUser
              ? {
                  value: majorUser.uuid,
                  label: (
                    <span>
                      <FontAwesomeIcon icon="user" style={{ marginRight: "6px" }} />
                      {majorUser.username}
                    </span>
                  )
                }
              : null,
            users: users
              ? users.map(user => ({
                  value: user.uuid,
                  label: (
                    <span>
                      <FontAwesomeIcon icon="user" style={{ marginRight: "6px" }} />
                      {user.username}
                    </span>
                  ),
                  tag: (
                    <CommonTag
                      key={user.uuid}
                      icon={<FontAwesomeIcon icon="user" style={{ marginRight: "6px" }} />}
                      className="__mr0"
                    >
                      {`${user.username}（${user.telephone}）`}
                    </CommonTag>
                  )
                }))
              : [],
            parking_spaces: parking_spaces
              ? parking_spaces.map(parking_space => ({
                  value: parking_space.parking_space_id,
                  label: (
                    <span key={parking_space.parking_space_id}>
                      {parking_space.parking_space_pattern_type === "motor" ? (
                        <Motor
                          style={{
                            width: 22,
                            height: 22,
                            marginRight: 4,
                            paddingTop: 9,
                            color: "#000"
                          }}
                        />
                      ) : (
                        <FontAwesomeIcon icon="car" style={{ marginRight: "6px" }} />
                      )}
                      {`No.${parking_space.parking_space_number}（B${parking_space.parking_space_floor_at}）`}
                    </span>
                  )
                }))
              : [],
            access_cards: access_cards
              ? access_cards.map(access_card => ({
                  value: access_card.id,
                  label: (
                    <span key={access_card.id}>
                      <Tooltip title={access_card.note}>
                        <FontAwesomeIcon icon="credit-card" style={{ marginRight: "6px" }} />
                        {access_card.card_number}
                        {access_card.note && (
                          <InfoCircleOutlined
                            style={{ fontSize: "16px", marginLeft: "5px", marginRight: "2px" }}
                          />
                        )}
                      </Tooltip>
                    </span>
                  )
                }))
              : []
          };
          cbSuccess && cbSuccess(transferedHousehold);
        },
        error => {
          dispatch({
            type: householdConstants.GET_HOUSEHOLD_EDIT_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重設建物住戶資訊
   * @returns
   */
  resetGetEdited: () => ({
    type: householdConstants.RESET_HOUSEHOLD_EDIT_SUCCESS
  }),
  getAccessCardByNumber: (constructionUuid, cardNumber, cbSuccess, cbError, option) => {
    return dispatch => {
      if (option?.loading) dispatch(maskActions.toggleMask(true));

      dispatch({
        type: householdConstants.GET_CARD_BY_NUMBER_REQUEST
      });

      accessCardService
        .getByNumber(constructionUuid, cardNumber)
        .then(
          card => {
            cbSuccess && cbSuccess(card);
          },
          res => {
            if (cbError) {
              cbError(res);
            } else {
              message.error(res.message);
            }
          }
        )
        .finally(() => {
          dispatch({
            type: householdConstants.GET_CARD_BY_NUMBER_DONE
          });

          if (option?.loading) dispatch(maskActions.toggleMask(false));
        });
    };
  },
  __getAll: (dispatch, getState) => {
    const { households } = getState();
    dispatch(
      householdActions.getAll(households?.query?.constructionUuid, households?.query?.condition)
    );
  },
  /**
   * 戶別綁定使用者
   * @param {string} constructionUuid - 建案 uuid
   * @param {string} userUuid - 使用者 uuid
   * @param {object} info - 加入戶別的資訊
   * @param {function} cbSuccess - 成功後的 callback
   *
   * @returns
   */
  joinHouseholdByUser: (construcitonUuid, userUuid, info, cbSuccess) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      householdService
        .joinHouseholdByUser(construcitonUuid, userUuid, info)
        .then(
          response => {
            cbSuccess && cbSuccess(response);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 戶別綁定門禁卡
   * @param {string} cardId - 門禁卡 id
   * @param {object} info - 加入戶別的資訊
   * @param {function} cbSuccess - 成功後的 callback
   *
   * @returns
   */
  joinHouseholdByCard: (householdId, cardId, cbSuccess) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      householdService
        .joinHouseholdByCard(householdId, cardId)
        .then(
          response => {
            cbSuccess && cbSuccess(response);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 住戶參數設定
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 住戶參數設定
   * @param {function} cbSuccess - 成功後的 callback
   * @param {function} cbError - 失敗後的 callback
   * @returns
   */
  settingHouseholdUserConfig: (constructionUuid, info, cbSuccess, cbError) => {
    return dispatch => {
      dispatch({ type: householdConstants.SETTING_HOUSEHOLD_USER_CONFIG_REQUEST });
      householdService
        .settingHouseholdUserConfig(constructionUuid, info)
        .then(
          response => {
            cbSuccess && cbSuccess(response);
          },
          error => {
            cbError && cbError(error);
          }
        )
        .finally(() => {
          dispatch({ type: householdConstants.SETTING_HOUSEHOLD_USER_CONFIG_DONE });
        });
    };
  }
};
